import { updateStatusBarColor } from 'utils/updateStatusBarColor'
import { useEffect, useRef, useState } from 'react'
import Vara from 'vara'
import './index.scss'
import useTranslation from 'hooks/useTranslation'

interface FireAnimationProps{
  onClose: () => void
}

const FireAnimation: React.FC<FireAnimationProps> = ({onClose}) => {
  const { t } = useTranslation('profile')
  const [flameVisible, setFlameVisible] = useState(false)
  const [showContent, setShowContent] = useState(false)
  const [showBg, setShowBg] = useState(false)
  const varaRef = useRef<any | null>(null)

  const handleClose = () => {

    const timer01 = setTimeout(() => {
      setFlameVisible(false)
    }, 10)

    const timer02 = setTimeout(() => {
      setShowContent(false)
    }, 20)

    const timer03 = setTimeout(() => {
      setShowBg(false)
    }, 50)
    
    const timer04 = setTimeout(() => {
      onClose()
      updateStatusBarColor('#ffffff')
    }, 1000)

    return () => {
      clearTimeout(timer01)
      clearTimeout(timer02)
      clearTimeout(timer03)
      clearTimeout(timer04)
    }
    
  }

  useEffect(() => {
    const timer0 = setTimeout(() => {
      setShowBg(true)
      updateStatusBarColor('#000000')
    }, 10)

    const timer1 = setTimeout(() => {
      setShowContent(true)
    }, 1000)

    const timer2 = setTimeout(() => {
      varaRef.current = new Vara(
        "#text-container",
        "https://rawcdn.githack.com/akzhy/Vara/ed6ab92fdf196596266ae76867c415fa659eb348/fonts/Satisfy/SatisfySL.json",
        [
          {
            text: t('candle_has_been_lit'),
            y: 50,
            fromCurrentPosition: { y: false },
            duration: 1800,
          },
        ],
        {
          strokeWidth: 2,
          color: "#fff",
          fontSize: 24,
          textAlign: "center",
        }
      )
    }, 1400)

    const timer3 = setTimeout(() => {
      setFlameVisible(true)
    }, 2000)

    return () => {
      clearTimeout(timer0)
      clearTimeout(timer1)
      clearTimeout(timer2)
      clearTimeout(timer3)
    }
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={`fireanimation__bg ${showBg ? 'visible' : ''}`}>
      <div id="text-container" className={`${showContent ? 'visible' : ''}`}></div>
      <div className={`holder ${showContent ? 'visible' : ''}`}>
        <div className="candle">
          <div className={`blinking-glow ${flameVisible ? 'visible' : ''}`}></div>
          <div className="thread"></div>
          <div className={`glow ${flameVisible ? 'visible' : ''}`}></div>
          <div className={`flame ${flameVisible ? 'visible' : ''}`}></div>
        </div>
      </div>
      <div className={`fireanimation__footer ${showContent ? 'visible' : ''}`}>
        <button onClick={handleClose} className='btn btn--secondary'>{t('go_back_to_profile')}</button>
      </div>
    </div>
  )
}

export default FireAnimation
